export function useFetchCategoryBySeoPath() {
  const { apiClient } = useShopwareContext()
  const category = ref(null)
  const loading = ref(false)
  const error = ref(null)

  const fetchCategoryBySeoPath = async (seoPath: string) => {
    loading.value = true
    error.value = null

    try {
      const { data } = await apiClient.invoke(`category post /novu/headless/product-listing/${seoPath}`, {
        body: {
          associations: {
          },
          filter: [],
          category: {
            associations: {
            },
          },
        },
      })

      if (!data || !data.category) {
        throw new Error('No product found for the given SEO path.')
      }

      category.value = data.category
    } catch (err) {
      error.value = err.message || 'Error fetching category.'
      console.error('Error fetching category by SEO path:', err)
    } finally {
      loading.value = false
    }
  }

  return {
    category,
    loading,
    error,
    fetchCategoryBySeoPath,
  }
}
